/**
 * Export checklist as text file
 */
export const exportChecklistToText = (checklist, completedSteps, stepTimestamps, notes, isDrillMode, elapsedTime) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const exportText = `
EMERGENCY CHECKLIST RECORD
==========================
Type: ${isDrillMode ? 'DRILL/PRACTICE' : 'REAL EMERGENCY'}
Checklist: ${checklist.title}
Date: ${new Date().toLocaleString()}
Duration: ${formatTime(elapsedTime)}
${!isDrillMode ? 'LOGBOOK ENTRY: Automatic entry created' : 'DRILL MODE: No logbook entry'}

STEPS COMPLETED:
${checklist.steps.map(step => {
  const stepId = step.id || step.text;
  const isCompleted = completedSteps.has(stepId);
  const timestamp = stepTimestamps[stepId];
  return `[${isCompleted ? 'X' : ' '}] ${step.text}${step.required === false ? ' (Optional)' : ''}${
    timestamp ? ` - Completed at ${new Date(timestamp).toLocaleTimeString()}` : ''
  }`;
}).join('\n')}

NOTES:
${notes || 'No additional notes'}

REFERENCE:
${checklist.reference || 'N/A'}
  `.trim();

  // Create download
  const blob = new Blob([exportText], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `emergency_${checklist.type}_${new Date().toISOString().split('T')[0]}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};